@if (currentUser.userName) {
  <div class="navigation-wrapper">
    <stine-navigation-bar
      (toggleSidenav)="drawer.toggle()"
      (logoff)="drawer.close()"
      (toggleStineMenu)="toggleSidenav()"
      [topNavRoutes]="sideNavRoutes"
    >
    </stine-navigation-bar>

    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav
        #drawer
        class="sidenav"
        [opened]="isSidenavOpened"
        [class.opened]="isSidenavOpened"
        mode="over"
        position="start"
      >
        <mat-nav-list>
          <stine-menu-list-item
            *ngFor="let sideNavRoute of sideNavRoutes"
            [sideNavRoute]="sideNavRoute"
          ></stine-menu-list-item>
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content>
        <!-- Empty content -->
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}
